"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inRange = exports.getRandomInt = exports.xor = exports.bin = exports.safeSum = void 0;
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("underscore"));
// Sum function which replaces undefined, null, and NaN with 0
function safeSum() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    return _.reduce(numbers, function (acc, num) { return acc + (num || 0); }, 0);
}
exports.safeSum = safeSum;
// Converts a boolean-ish value to its binary representation
function bin(value) {
    return value ? 1 : 0;
}
exports.bin = bin;
var xor = function (p, q) { return (!p && q) || (p && !q); };
exports.xor = xor;
// Returns a random integer >= 0 and < max
function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}
exports.getRandomInt = getRandomInt;
// return true if in range (inclusive), otherwise false
function inRange(x, min, max) {
    return (x - min) * (x - max) <= 0;
}
exports.inRange = inRange;
//# sourceMappingURL=math.js.map